import queueSettings from "@/store/modules/Queue/queueSettings"

const queueModules = {
  queueSettings
}

export default queueModules
